import React, { forwardRef, useRef } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box } from '@mui/material';

const modules = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    [{ 'font': [] }],  // Font family
    [{ 'size': ['small', false, 'large', 'huge'] }],  // Font size
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'align': [] }],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],  // Subscript/superscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],  // Indentation
    [{ 'direction': 'rtl' }],  // Text direction
    ['blockquote', 'code-block'],
    ['link', 'image', 'video'],
    ['clean']
  ],
  clipboard: {
    matchVisual: false
  }
};

const formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike',
  'align', 'direction',
  'color', 'background',
  'list', 'bullet', 'indent',
  'script',
  'blockquote', 'code-block',
  'link', 'image', 'video'
];

const Editor = forwardRef(({ value, onChange }, ref) => {
  const quillRef = useRef(null);

  React.useImperativeHandle(ref, () => ({
    getEditor: () => quillRef.current?.getEditor(),
    focus: () => quillRef.current?.focus()
  }));

  return (
    <Box
      sx={{
        '& .ql-container': {
          height: '300px',
          fontSize: '1rem',
          fontFamily: 'inherit'
        },
        '& .ql-editor': {
          minHeight: '300px'
        },
        '& .ql-toolbar': {
          borderTopLeftRadius: 1,
          borderTopRightRadius: 1,
          display: 'flex',
          flexWrap: 'wrap',
          gap: '5px',
          padding: '8px'
        },
        '& .ql-formats': {
          display: 'inline-flex',
          alignItems: 'center',
          marginRight: '10px'
        },
        '& .ql-container': {
          borderBottomLeftRadius: 1,
          borderBottomRightRadius: 1
        }
      }}
    >
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        theme="snow"
      />
    </Box>
  );
});

Editor.displayName = 'Editor';

export default Editor; 